import api from './api';
import { GET_ACTIVE_SUBSCRIPTION, REQUEST_SUBSCRIPTION_ACTIVATION } from '../configs/routes';

export const getActiveSubscription = () =>
    new Promise((resolve, reject) => {
        api.get(GET_ACTIVE_SUBSCRIPTION)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const requestSubscriptionActivation = (data) =>
    new Promise((resolve, reject) => {
        api.post(REQUEST_SUBSCRIPTION_ACTIVATION, data)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });
